// import React, { useRef } from 'react';
// import './ThermalBillPdf.css';
// import { Button } from '@mui/material';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import { MessageData } from './MessageData';
// import numWords from 'num-words';
// import { Link } from 'react-router-dom';
// import { useReactToPrint } from 'react-to-print';

// const ThermalBillPdf = ({ data, helpers }) => {
//   const { capitalizeWords } = helpers || {};
//   const printRef = useRef()
//   // const handlePrint = () => {
//   //     window.print();
//   // };

//   const handlePrint = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: `Invoice_${data?.invoice || 'YourSalon'}`,
//     removeAfterPrint: true
//   })

//   const handleWhatsAppShare = () => {
//     const url = MessageData(data, {}, data.branchDetails, data.feedbackUrl, data.billUrl);
//     window.open(url, '_blank');
//   };

//   const formatAmountInWords = (amount) => {
//     if (typeof amount !== "number" || isNaN(amount)) return "Zero";

//     const [rupees, paise] = amount.toString().split(".");

//     let words = capitalizeWords(numWords(parseInt(rupees))) + " Rupees";
//     if (paise && parseInt(paise) > 0) {
//       words += " and " + capitalizeWords(numWords(parseInt(paise))) + " Paise";
//     }
//     return words + " Only";
//   };

//   const isWalletBill = data?.billType === 'Wallet';
//   return (
//     <div className="print-section thermal-container">
//       <div className="thermal-main-div">
//         <div className="thermal-bill-container" ref={printRef}>
//           <div className="thermal-header">
//             <img src={data?.branchDetails?.logo?.url} className="thermal-logo" alt="" />
//             <h1 className="thermal-salon-name">{data?.branchDetails?.branchName}</h1>
//             <p className="thermal-address">{data?.branchDetails?.address}</p>
//             <p className="thermal-phone">Contact : {data?.branchDetails?.branchPhone}</p>
//           </div>

//           <h3 className="thermal-tax">INVOICE</h3>
//           <div className="thermal-gstin-box">
//             <div className="thermal-dashed-line"></div>
//             <p>
//               <strong>GSTIN:</strong> {data?.branchDetails?.gstNumber || 'Unregistered'}
//             </p>
//             <div className="thermal-dashed-line"></div>
//           </div>

//           <div className="thermal-details-two-column">
//             <div className="thermal-col">
//               <p>
//                 <strong>Customer Name:</strong> {data?.clientName}
//               </p>
//               <p>
//                 <strong>Invoice No.:</strong> {data?.invoice}
//               </p>
//             </div>
//             <div className="thermal-col">
//               <p>
//                 <strong>Contact:</strong> {data?.clientNumber}
//               </p>
//               <p>
//                 <strong>Date & Time:</strong> {data?.formattedDate}
//                 <br />
//                 {data?.formattedTime}
//               </p>
//             </div>
//               {data?.ownerId === "68273f689a2875f3d47ec010" && (
//             <div className="thermal-col">
//                 <p>
//                 <strong>Address:</strong> {data?.clientAddress}
//                 <br />
//               </p>
//               <p>
//                 <strong>Gst Number:</strong> {data?.clientGstNumber}
//               </p>
//               <p>
//                 <strong>Place of supply:</strong> {data?.clientPos}
//                 <br />
//               </p>
//             </div>
//           )}
//           </div>

//           {!isWalletBill && (
//             <>
//               <div className="thermal-section-title">SERVICES & PRODUCTS</div>
//               <table className="thermal-items">
//                 <thead>
//                   <tr>
//                     <th>Description</th>
//                     {/* {data?.products.length > 0  ? <th>HSN Code</th> : ''} */}
//                     <th>Rate</th>
//                     <th>Qty</th>
//                     <th>Discount</th>
//                     {data?.taxes?.taxType === 'Exclusive' ? <th>Gst</th> : ''}
//                     <th>Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* {data?.services?.map((item, index) => (
//                                 <tr key={`thermal-service-${index}`}>
//                                     <td>{item.serviceName}<br /></td>
//                                     <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
//                                     <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                                     <td style={{ color: item.discount > 0 ? '#000' : 'inherit', textAlign: 'center' }}>
//                                         {item?.discount
//                                             ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                                             : '0%'}
//                                     </td>
//                                     <td style={{ textAlign: 'center' }}>₹{item.amount}</td>
//                                 </tr>
//                             ))}
//                             {data?.products?.map((item, index) => (
//                                 <tr key={`thermal-product-${index}`}>
//                                     <td>{item.productName}<br /><small>Qty: {item.quantity}</small></td>
//                                     <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
//                                     <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                                     <td style={{ color: item.discount > 0 ? '#000' : 'inherit', textAlign: 'center' }}>
//                                         {item?.discount
//                                             ? `${parseFloat(item.discount).toFixed(2)}${item.discountType}`
//                                             : '0%'}
//                                     </td>
//                                     <td style={{ textAlign: 'center' }}>₹{item.amount}</td>
//                                 </tr>
//                             ))} */}
//                   {data?.billType === 'Membership' &&
//                     data?.memberships?.map((item, index) => (
//                       <tr key={`thermal-membership-${index}`}>
//                         <td>{item.membershipName}</td>
//                         <td>₹{parseFloat(item?.price).toFixed(2)}</td>
//                         <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                         <td
//                           style={{
//                             color: item.discount > 0 ? '#000' : 'inherit',
//                             textAlign: 'center',
//                           }}
//                         >
//                           {item?.discount
//                             ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                             : '0%'}
//                         </td>
//                         {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                         <td style={{ textAlign: 'center' }}>
//                           ₹
//                           {item?.amount ||
//                             item.price -
//                             (item.discountType === '%'
//                               ? (item.price * item.discount) / 100
//                               : item.discount) *
//                             item.quantity}
//                         </td>
//                       </tr>
//                     ))}

//                   {data?.billType === 'Package' &&
//                     data?.packages?.map((item, index) => (
//                       <tr key={`thermal-package-${index}`}>
//                         <td>{item.packageName}</td>
//                         <td>₹{parseFloat(item?.price).toFixed(2)}</td>
//                         <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                         <td
//                           style={{
//                             color: item.discount > 0 ? '#000' : 'inherit',
//                             textAlign: 'center',
//                           }}
//                         >
//                           {item?.discount
//                             ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                             : '0%'}
//                         </td>
//                         {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                         <td style={{ textAlign: 'center' }}>
//                           ₹
//                           {item?.amount ||
//                             item.price -
//                             (item.discountType === '%'
//                               ? (item.price * item.discount) / 100
//                               : item.discount) *
//                             item.quantity}
//                         </td>
//                       </tr>
//                     ))}

//                   {data?.billType !== 'Membership' &&
//                     data?.billType !== 'Package' &&
//                     data?.services?.map((item, index) => (
//                       <tr key={`thermal-service-${index}`}>
//                         <td>{item.serviceName}</td>
//                          {/* {
//                           item?.hsnCode
//                             ? `${item?.hsnCode}` : data.products.length > 0 ? <td style={{ textAlign: 'center' }}>-</td> : ""
//                         } */}
//                         <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
//                         <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                         <td
//                           style={{
//                             color: item.discount > 0 ? '#000' : 'inherit',
//                             textAlign: 'center',
//                           }}
//                         >
//                           {item?.discount
//                             ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                             : '0%'}
//                         </td>
//                         {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                         <td style={{ textAlign: 'center' }}>₹{item.amount}</td>
//                       </tr>
//                     ))}

//                   {data?.products?.map((item, index) => (
//                     <tr key={`thermal-product-${index}`}>
//                       <td>
//                         {item.productName}
//                         <br />
//                         <small>Qty: {item.quantity}</small>
//                       </td>
//                       {/* <td>
//                       {
//                         item?.product?.hsnCode
//                           ? `${item?.product?.hsnCode}` : "-"
//                       }
//                     </td> */}
//                       <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
//                       <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                       <td
//                         style={{
//                           color: item.discount > 0 ? '#000' : 'inherit',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {item?.discount
//                           ? `${parseFloat(item.discount).toFixed(2)}${item.discountType}`
//                           : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>18%</td>}
//                       <td style={{ textAlign: 'center' }}>₹{item.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </>
//           )}

//           {/* {
//                         isWalletBill && (
//                             <>
//                                 <div className="thermal-section-title">WALLET TRANSACTIONS</div>
//                                 <table className="thermal-items">
//                                     <thead>
//                                         <tr>
//                                             <th>Wallet Recharge</th>
//                                             <th>Amount</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         <tr>
//                                             <td>Value of Amount</td>
//                                             <td style={{ textAlign: 'center' }}>₹{data?.amountAdded}</td>
//                                         </tr>
//                                         {data?.preAdvanceUsed > 0 && (
//                                             <tr>
//                                                 <td>Previous Wallet Balance Used</td>
//                                                 <td style={{ textAlign: 'center' }}>-₹{data?.preAdvanceUsed}</td>
//                                             </tr>
//                                         )}
//                                         {data?.amountPaid?.map((payment, index) => (
//                                             <tr key={`payment-${index}`}>
//                                                 <td>Amount Received</td>
//                                                 <td style={{ textAlign: 'center' }}>₹{payment?.amount}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </>

//                         )
//                     } */}

//           <div className="thermal-total-summary">
//             {
//               isWalletBill && <div className="thermal-total-row">
//                 <span>Amount Credited in Wallet:</span>
//                 <span>₹{data.amountAdded}</span>
//               </div>
//             }
//             <div className="thermal-total-row">
//               <span>Subtotal:</span>
//               <span>
//                 ₹
//                 {data?.billType === 'Membership'
//                   ? parseFloat(data?.memberships?.[0]?.price || 0).toFixed(2)
//                   : data?.billType === 'Package'
//                     ? parseFloat(data?.packages?.[0]?.price || 0).toFixed(2)
//                     : parseFloat(data?.baseTotal || data?.subTotal || 0).toFixed(2)}
//               </span>
//             </div>

//             {(() => {
//               const additionalDiscount = [...(data?.services || []), ...(data?.products || [])]
//                 .filter((item) => item.discount > 0 && item.discount !== 100)
//                 .reduce((sum, item) => {
//                   if (item.discountType === '%') {
//                     return sum + Math.round((item.price * item.quantity * item.discount) / 100);
//                   } else {
//                     return sum + item.discount;
//                   }
//                 }, 0);

//               const shouldShowAdditionalDiscount =
//                 additionalDiscount > 0 &&
//                 (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

//               return (
//                 shouldShowAdditionalDiscount && (
//                   <div className="thermal-total-row thermal-discount">
//                     <span>Additional Discount:</span>
//                     <span>-₹{Math.round(additionalDiscount)}</span>
//                   </div>
//                 )
//               );
//             })()}

//             {data?.useMembership && data?.services?.some((s) => s.discount === 100) && (
//               <div className="thermal-total-row thermal-discount">
//                 <span>Membership Discount:</span>
//                 <span>
//                   -₹
//                   {data.services
//                     .filter((s) => s.discount === 100)
//                     .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                 </span>
//               </div>
//             )}

//             {data?.coupon?.discountAmount > 0 && (
//               <div className="thermal-total-row thermal-discount">
//                 <span>Coupon Discount:</span>
//                 <span>-₹{data?.coupon?.discountAmount}</span>
//               </div>
//             )}

//             {data?.packageUniqueId?.length > 0 && data.services?.some((s) => s.discount === 100) && (
//               <div className="thermal-total-row thermal-discount">
//                 <span>Package Discount:</span>
//                 <span>
//                   -₹
//                   {data.services
//                     .filter((s) => s.discount === 100)
//                     .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                 </span>
//               </div>
//             )}

//             {data?.rewardPointRedeemAmount > 0 && (
//               <div className="thermal-total-row thermal-discount">
//                 <span>Reward Points:</span>
//                 <span>-₹{data?.rewardPointRedeemAmount}</span>
//               </div>
//             )}

//             <div className="thermal-total-row thermal-net-amount">
//               <span>Net Amount (After Discounts):</span>
//               <span>
//                 ₹
//                 {data.rewardPointRedeemAmount > 0
//                   ? parseFloat(data?.subTotal || 0) - data.rewardPointRedeemAmount
//                   : parseFloat(data?.subTotal || 0)}
//               </span>
//             </div>

//             {data?.taxes?.taxType === 'Exclusive' && (
//               <>
//                 <div className="thermal-total-row">
//                   <span>SGST :</span>
//                   <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                 </div>
//                 <div className="thermal-total-row">
//                   <span>CGST :</span>
//                   <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                 </div>
//               </>
//             )} 

//             <div className="thermal-total-row thermal-total-payable">
//               <span>Total Payable:</span>
//               <span>₹{data?.amountPayable}</span>
//             </div>

//             <div className="thermal-total-row thermal-amount-received">
//               <span>Amount Received:</span>
//               <span>₹{data?.amountPaid?.reduce((a, b) => a + Number(b.amount), 0)}</span>
//             </div>

//             <div className="thermal-total-row thermal-due-amount">
//               <span>Due Balance:</span>
//               <span>₹{data?.paidDues || 0}</span>
//             </div>

//             {data?.remainingWalletAmount && (
//               <div className="thermal-total-row">
//                 <span>Remaining Wallet Balance:</span>
//                 <span style={{ color: '#000', fontWeight: 'bold' }}>
//                   ₹{data?.remainingWalletAmount}
//                 </span>
//               </div>
//             )}

//             <div className="thermal-amount-words">
//               <p>
//                 <strong>Amount in words:</strong> {formatAmountInWords(data?.amountPayable)}
//               </p>
//             </div>

//           </div>

//           <div className="thermal-thankyou">
//             <p>*** THANK YOU ***</p>
//             <p>We Look Forward To Your Next Visit</p>
//           </div>

//           <div className="thermal-footer">
//             <p>
//               This Bill is Powered by <Link to="https://yoursalon.in/">YourSalon.in</Link>
//             </p>
//           </div>

//           <div className="thermal-action-buttons">
//             <Button onClick={handlePrint} className="thermal-print-button" variant="contained">
//               Print Bill
//             </Button>
//             <Button
//               onClick={handleWhatsAppShare}
//               className="thermal-whatsapp-button"
//               variant="contained"
//               sx={{
//                 backgroundColor: '#25D366',
//               }}
//               startIcon={<WhatsAppIcon />}
//             >
//               WhatsApp
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ThermalBillPdf;

import React, { useRef } from 'react';
import './ThermalBillPdf.css';
import { Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { MessageData } from './MessageData';
import numWords from 'num-words';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { changeDateFormate } from "../../../utils/dateutils"
const ThermalBillPdf = ({ data, helpers }) => {
  const { capitalizeWords } = helpers || {};
  const printRef = useRef();

  // Bill type conditions
  const isMembershipBill = data?.billType === 'Membership';
  const isPackageBill = data?.billType === 'Package';
  const isWalletBill = data?.billType === 'Wallet';
  const isRegularBill = data?.billType === 'Bill';

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Invoice_${data?.invoice || 'YourSalon'}`,
    removeAfterPrint: true
  });

  const handleWhatsAppShare = () => {
    const url = MessageData(data, {}, data.branchDetails, data.feedbackUrl, data.billUrl);
    window.open(url, '_blank');
  };

  const formatAmountInWords = (amount) => {
    if (typeof amount !== "number" || isNaN(amount)) return "Zero Rupees Only";

    const [rupees, paise] = amount.toString().split(".");
    let words = capitalizeWords(numWords(parseInt(rupees))) + " Rupees";

    if (paise && parseInt(paise) > 0) {
      words += " and " + capitalizeWords(numWords(parseInt(paise))) + " Paise";
    }
    return words + " Only";
  };

  // Helper functions for different bill types
  // const renderServicesList = () => {
  //   if (isMembershipBill && data?.membershipDetails?.servicesOffered) {
  //     return (
  //       <div className="thermal-services-list">
  //         <div className="thermal-section-title">MEMBERSHIP SERVICES</div>
  //         <table className="thermal-services-table">
  //           <thead>
  //             <tr>
  //               <th>Service Name</th>
  //               <th>Sessions</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {data.membershipDetails.servicesOffered.map((serviceItem, index) => (
  //               <tr key={index}>
  //                 <td>• {serviceItem.service?.serviceName}</td>
  //                 <td style={{ textAlign: 'center' }}>{serviceItem.availableCount || '0'}</td>
  //               </tr>
  //             ))}
  //           </tbody>
  //         </table>
  //       </div>
  //     );
  //   }

  //   if (isPackageBill && data?.servicesPackage?.services) {
  //     return (
  //       <div className="thermal-services-list">
  //         <div className="thermal-section-title">PACKAGE SERVICES</div>
  //         <table className="thermal-services-table">
  //           <thead>
  //             <tr>
  //               <th>Service Name</th>
  //               <th>Sessions</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {data.servicesPackage.services.map((service, index) => (
  //               <tr key={index}>
  //                 <td>• {service.serviceName}</td>
  //                 <td style={{ textAlign: 'center' }}>1</td>
  //               </tr>
  //             ))}
  //           </tbody>
  //         </table>
  //       </div>
  //     );
  //   }

  //   return null;
  // };
  // For ThermalBillPdf component
  const hasRemainingServices = data?.remainingServices?.length > 0;
  const hasDueHistory = data?.dueBillHistory?.length > 0;
  const renderDueHistoryTable = () => {
    if (!hasDueHistory) return null;
    let remainingAmount = 0;
    let totalAmount = data.paidDues - remainingAmount;

    return (
      <div className="thermal-Remainingservices-list">
        <h6 style={{ marginTop: '10px' }} className="thermal-section-title">
          {data?.dueBillHistory.length > 0 ? 'Due Cleared History:' : ''}
        </h6>
        <div className="thermal-Remainingservices-table">
          {/* <table className="thermal-items"> */}
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th style={{ textAlign: 'center' }}>Total</th>
                <th style={{ textAlign: 'center' }}>Paid</th>
                {/* <th style={{ textAlign: 'center' }}>Payment Mode</th> */}
                <th style={{ textAlign: 'center' }}>Due</th>
              </tr>
            </thead>
            <tbody>
              {data.dueBillHistory.map((history, index) => {
                remainingAmount = totalAmount - history.paidAmount;
                const row = (
                  <tr key={index}>
                    <td>{changeDateFormate(history.paymentDate)}</td>
                    <td style={{ textAlign: 'center' }}>{totalAmount}</td>
                    <td style={{ textAlign: 'center' }}>{history.paidAmount}</td>
                    {/* <td style={{ textAlign: 'center' }}>{history.paymentType}</td> */}
                    <td style={{ textAlign: 'center' }}>{remainingAmount}</td>
                  </tr>
                );
                totalAmount = remainingAmount;
                return row;
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderRemainingServicesTable = () => {
    if (!hasRemainingServices) return null;

    return (
      <div className="thermal-Remainingservices-list">
        <h6>{data?.packageUniqueId.length > 0 ? 'Remaining Package Services:' : "Remaining Membership Services:"}</h6>
        <div className="thermal-Remainingservices-table">
          <table>
            <thead>
              <tr>
                <th>Service Name</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {data?.remainingServices.map((service, index) => (
                <tr key={index}>
                  <td>• {service.serviceName}</td>
                  <td style={{ textAlign: 'center' }}>
                    {service.count || 1}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderServicesList = () => {
    if (isMembershipBill && data?.membershipDetails) {
      const { membershipType, servicesOffered, discount } = data.membershipDetails;

      if (membershipType === 'serviceType' && servicesOffered?.length > 0) {
        return (
          <div className="thermal-services-list">
            <div className="thermal-section-title">MEMBERSHIP SERVICES</div>
            <table className="thermal-services-table">
              <thead>
                <tr>
                  <th>Service Name</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {servicesOffered.map((serviceItem, index) => (
                  <tr key={index}>
                    <td>• {serviceItem.service?.serviceName}</td>
                    <td style={{ textAlign: 'center' }}>{serviceItem.availableCount || '0'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      }

      if (membershipType === 'discountType' && discount) {
        return (
          <div className="thermal-services-list">
            <div className="thermal-section-title">MEMBERSHIP BENEFITS</div>
            <table className="thermal-services-table">
              <tbody>
                {discount.discountOnService > 0 && (
                  <tr>
                    <td>Discount on Service:</td>
                    <td style={{ textAlign: 'center' }}>{discount.discountOnService}{discount.serviceDiscountType === '%' ? '%' : '₹'}</td>
                  </tr>
                )}
                {discount.discountOnProduct > 0 && (
                  <tr>
                    <td>Discount on Product:</td>
                    <td style={{ textAlign: 'center' }}>{discount.discountOnProduct}{discount.productDiscountType === '%' ? '%' : '₹'}</td>
                  </tr>
                )}
                {discount.minBillAmount > 0 && (
                  <tr>
                    <td>Min Bill Amount:</td>
                    <td style={{ textAlign: 'center' }}>₹{discount.minBillAmount}</td>
                  </tr>
                )}
                {discount.availableCount > 0 && (
                  <tr>
                    <td>Available Count:</td>
                    <td style={{ textAlign: 'center' }}>{discount.availableCount} Count</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      }
    }

    if (isPackageBill && data?.servicesPackage?.services) {
      return (
        <div className="thermal-services-list">
          <div className="thermal-section-title">PACKAGE SERVICES</div>
          <table className="thermal-services-table">
            <thead>
              <tr>
                <th>Service Name</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {data.servicesPackage.services.map((service, index) => (
                <tr key={index}>
                  <td>• {service.serviceName}</td>
                  <td style={{ textAlign: 'center' }}>1</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return null;
  };

  const renderMainTable = () => {
    if (isWalletBill) {
      return renderWalletTable();
    }

    // Dynamic section title based on bill type
    const getSectionTitle = () => {
      switch (data?.billType) {
        case 'Package':
          return 'PACKAGE';
        case 'Membership':
          return 'MEMBERSHIP';
        case 'Bill':
        default:
          return 'SERVICES & PRODUCTS';
      }
    };
    const showGstColumn = !!data?.branchDetails?.gstNumber;

    return (
      <>
        <div className="thermal-section-title">{getSectionTitle()}</div>
        <table className="thermal-items">
          <thead>
            <tr>
              <th>Description</th>
              <th>Taxable Value</th>
              <th>Qty</th>
              <th>Disc</th>
              {showGstColumn && <th>Gst</th>}
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {renderTableRows(showGstColumn)}
          </tbody>
        </table>
      </>
    );
  };

  const renderTableRows = (showGstColumn) => {
    if (isMembershipBill) {
      return data?.memberships?.map((item, index) => (
        <ThermalTableRow
          key={`thermal-membership-${index}`}
          description={item?.membershipName}
          price={item?.price}
          quantity={item?.quantity}
          discount={item?.discount}
          discountType={item?.discountType}
          amount={item?.amount || calculateAmount(item)}
          showGst={showGstColumn}
          gstRate={data?.taxes?.SGST}
          taxStatus={item?.taxStatus}
          gstPercent={item?.gstPercent}
          gstValue={item?.gstValue}
        />
      ));
    }

    if (isPackageBill) {
      return data?.packages?.map((item, index) => (
        <ThermalTableRow
          key={`thermal-package-${index}`}
          description={item?.packageName}
          price={item?.price}
          quantity={item?.quantity}
          discount={item?.discount}
          discountType={item?.discountType}
          amount={item?.amount || calculateAmount(item)}
          showGst={showGstColumn}
          gstRate={data?.taxes?.SGST}
          taxStatus={item?.taxStatus}
          gstPercent={item?.gstPercent}
          gstValue={item?.gstValue}
        />
      ));
    }

    // Regular bill with services and products
    return (
      <>
        {data?.services?.map((item, index) => (
          <ThermalServiceRow
            key={`thermal-service-${index}`}
            item={item}
            showGst={showGstColumn}
            gstRate={data?.taxes?.SGST}
            gstData={data?.taxes}
          />
        ))}
        {data?.products?.map((item, index) => (
          <ThermalProductRow
            key={`thermal-product-${index}`}
            item={item}
            showGst={showGstColumn}
          />
        ))}
      </>
    );
  };

  const renderWalletTable = () => {
    return (
      <>
        <div className="thermal-section-title">WALLET</div>
        <table className="thermal-items">
          <thead>
            <tr>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amount Credited</td>
              <td style={{ textAlign: 'center' }}>₹{data?.amountAdded}</td>
            </tr>
            {data?.preAdvanceUsed > 0 && (
              <tr>
                <td>Prev Balance Used</td>
                <td style={{ textAlign: 'center' }}>-₹{data?.preAdvanceUsed}</td>
              </tr>
            )}
            <tr>
              <td>Amount Received</td>
              <td style={{ textAlign: 'center' }}>
                ₹{data?.amountPaid?.reduce((acc, payment) => acc + payment?.amount, 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </>
    );
  };

  const calculateAmount = (item) => {
    const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 1;
    if (item.discountType === '%') {
      const discountAmount = (price * item.discount) / 100;
      return (price - discountAmount) * quantity;
    } else {
      // INR discount: flat amount deducted from total
      return Math.max(0, (price * quantity) - (Number(item.discount) || 0));
    }
  };

  return (
    <div className="print-section thermal-container">
      <div className="thermal-main-div">
        <div className="thermal-bill-container" ref={printRef}>
          {/* Header Section */}
          <div className="thermal-header">
            <h1 className="thermal-salon-name">{data?.branchDetails?.branchName}</h1>
            <p className="thermal-address">{data?.branchDetails?.address}</p>
            <p className="thermal-phone">Contact: {data?.branchDetails?.branchPhone}</p>
          </div>

          <h3 className="thermal-tax">INVOICE</h3>

          <div className="thermal-gstin-box">
            <div className="thermal-dashed-line"></div>
            <p>
              <strong>GSTIN:</strong> {data?.branchDetails?.gstNumber || 'Unregistered'}
            </p>
            <div className="thermal-dashed-line"></div>
          </div>

          {/* Client Details */}
          <div className="thermal-details-two-column">
            <div className="thermal-col">
              <p>
                <strong>Customer:</strong> {data?.clientName}
              </p>
              <p>
                <strong>Invoice No:</strong> {data?.invoice}
              </p>
              {data?.billType === 'Package' && (
                <p className="">
                  <strong>Bill Type:</strong> Package Bill
                </p>
              )}
              {data?.billType === 'Membership' && (
                <p className="">
                  <strong>Bill Type: </strong> Membership Bill
                </p>
              )}
            </div>
            <div className="thermal-col">
              <p>
                <strong>Contact:</strong> {data?.clientNumber}
              </p>
              <p>
                <strong>Date:</strong> {data?.formattedDate}
              </p>
              <p>
                <strong>Time:</strong> {data?.formattedTime}
              </p>
            </div>
          </div>

          {data?.branchDetails?.gstNumber && (
            <div className="thermal-client-details">
              <p>
                <strong>Address:</strong> {data?.clientAddress}
              </p>
              <p>
                <strong>GST No:</strong> {data?.clientGstNumber}
              </p>
              <p>
                <strong>Place of Supply:</strong> {data?.clientPos}
              </p>
            </div>
          )}

          {/* Main Content */}
          {renderMainTable()}

          {/* Services List for Membership and Package */}
          {(isMembershipBill || isPackageBill) && renderServicesList()}
          {data?.billType === 'Package' && (
            <p className="">
              <strong>Valid Till:</strong> {changeDateFormate(data?.endDate)}
            </p>
          )}
          {data?.billType === 'Membership' && (
            <p className="">
              <strong>Valid Till:</strong> {changeDateFormate(data?.endDate)}
            </p>
          )}
          {/* Remaining Services Table */}
          {hasRemainingServices && renderRemainingServicesTable()}

          {/* Summary Section */}
          <ThermalSummarySection
            data={data}
            isWalletBill={isWalletBill}
            formatAmountInWords={formatAmountInWords}
          />
          {hasDueHistory && renderDueHistoryTable()}

          {/* Footer */}
          <div className="thermal-thankyou">
            <p>*** THANK YOU ***</p>
            <p>We Look Forward To Your Next Visit</p>
          </div>

          <div className="thermal-footer">
            <p>
              Powered by <Link to="https://yoursalon.in/">YourSalon.in</Link>
            </p>
          </div>

          {/* Action Buttons (Hidden during print) */}
          <div className="thermal-action-buttons">
            <Button onClick={handlePrint} className="thermal-print-button" variant="contained">
              Print Bill
            </Button>
            <Button
              onClick={handleWhatsAppShare}
              className="thermal-whatsapp-button"
              variant="contained"
              sx={{ backgroundColor: '#25D366' }}
              startIcon={<WhatsAppIcon />}
            >
              WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable Table Row Components for ThermalBillPdf
const ThermalTableRow = ({
  description,
  price,
  quantity,
  discount,
  discountType,
  amount,
  showGst,
  gstRate,
  taxStatus,
  gstPercent,
  gstValue
}) => {
  const displayedPrice = (taxStatus === 'withTax' && gstPercent > 0)
    ? (Number(price || 0) / (1 + (gstPercent || 0) / 100)).toFixed(2)
    : parseFloat(price || 0).toFixed(2);

  return (
    <tr>
      <td>{description}</td>
      <td>₹{displayedPrice}</td>
      <td style={{ textAlign: 'center' }}>{quantity}</td>
      <td style={{ textAlign: 'center' }}>
        {discount ? `${Number(discount).toFixed(0)}${discountType}` : '0%'}
      </td>
      {showGst && (
        <td style={{ textAlign: 'center' }}>
          {!(Number(discount) === 100 && discountType === '%')
            ? `${gstPercent || 0}% (₹${(gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td style={{ textAlign: 'center' }}>₹{amount}</td>
    </tr>
  );
};

const ThermalServiceRow = ({ item, showGst, gstRate, gstData }) => {
  const displayedPrice = (item?.taxStatus === 'withTax' && item?.gstPercent > 0)
    ? (Number(item?.price || 0) / (1 + item.gstPercent / 100)).toFixed(2)
    : parseFloat(item?.price || 0).toFixed(2);

  return (
    <tr>
      <td>{item.serviceName}</td>
      <td>₹{displayedPrice}</td>
      <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
      <td style={{ textAlign: 'center' }}>
        {item?.discount
          ? `${Number(item.discount).toFixed(0)}${item.discountType}`
          : '0%'}
      </td>
      {showGst && (
        <td>
          {!(Number(item?.discount) === 100 && item?.discountType === '%') && item?.taxStatus !== 'noGst'
            ? `${item?.gstPercent || 0}% (₹${(item?.gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td style={{ textAlign: 'center' }}>₹{parseFloat(item.amount || 0).toFixed(2)}</td>
    </tr>
  );
};

const ThermalProductRow = ({ item, showGst }) => {
  const displayedProdPrice = (item?.taxStatus === 'withTax' && item?.gstPercent > 0)
    ? (Number(item?.price || 0) / (1 + item.gstPercent / 100)).toFixed(2)
    : parseFloat(item?.price || 0).toFixed(2);

  return (
    <tr>
      <td>{item.productName}</td>
      <td>₹{displayedProdPrice}</td>
      <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
      <td style={{ textAlign: 'center' }}>
        {item?.discount
          ? `${parseFloat(item.discount).toFixed(0)}${item.discountType}`
          : '0%'}
      </td>
      {showGst && (
        <td>
          {!(Number(item?.discount) === 100 && item?.discountType === '%')
            ? `${item?.gstPercent || 0}% (₹${(item?.gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td style={{ textAlign: 'center' }}>₹{parseFloat(item.amount || 0).toFixed(2)}</td>
    </tr>
  );
};

// Separate Summary Section Component for Thermal
const ThermalSummarySection = ({ data, isWalletBill, formatAmountInWords }) => {
  const totalGstFromItems = [
    ...(data?.services || []),
    ...(data?.products || []),
    ...(data?.memberships || []),
    ...(data?.packages || []),
  ].reduce((sum, item) => sum + (Number(item?.gstValue) || 0), 0);

  const totalGstValue = totalGstFromItems > 0 ? totalGstFromItems : Math.max(0, Number(data?.totalAmount || 0) - Number(data?.subTotal || 0));

  // Calculate taxable subtotal = sum of (amount with GST extracted if withTax)
  const calculateTaxableSubTotal = () => {
    const allItems = [
      ...(data?.services || []),
      ...(data?.products || []),
      ...(data?.memberships || []),
      ...(data?.packages || []),
    ];

    return allItems.reduce((sum, item) => {
      const price = Number(item?.price || 0);
      const quantity = Number(item?.quantity ?? 1);
      const taxStatus = item?.taxStatus || 'noGst';
      const isProduct = !item?.serviceName && !item?.membershipName && !item?.packageName;
      const gstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (isProduct
        ? (item?.product?.GST ?? item?.gst ?? 18)
        : (data?.taxes?.SGST || 0)));

      let taxableValue = price;
      if (taxStatus === 'withTax' && gstRate > 0) {
        taxableValue = Number((price / (1 + gstRate / 100)).toFixed(2));
      }

      return sum + (taxableValue * quantity);
    }, 0);
  };

  const taxableSubTotal = calculateTaxableSubTotal();

  const calculateAdditionalDiscount = () => {
    const totalDiscount = [...(data?.services || []), ...(data?.products || [])]
      .filter((item) => {
        const isFullPercentDiscount = Number(item.discount) === 100 && item.discountType === '%';
        return Number(item.discount) > 0 && !isFullPercentDiscount;
      })
      .reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const quantity = Number(item?.quantity || 1);
        const amount = Number(item?.amount || 0);
        const taxStatus = item?.taxStatus || 'noGst';
        const isProduct = !item?.serviceName && !item?.membershipName && !item?.packageName;
        const gstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (isProduct
          ? (item?.product?.GST ?? item?.gst ?? 18)
          : (data?.taxes?.SGST || 0)));

        let lineTotal = price * quantity;
        let finalAmount = amount;

        if (taxStatus === 'withTax' && gstRate > 0) {
          const taxablePrice = Number((price / (1 + gstRate / 100)).toFixed(2));
          lineTotal = taxablePrice * quantity;
          finalAmount = Number((amount / (1 + gstRate / 100)).toFixed(2));
        }

        const discountVal = lineTotal - finalAmount;
        return sum + discountVal;
      }, 0);

    return totalDiscount;
  };

  const additionalDiscount = calculateAdditionalDiscount();
  const shouldShowAdditionalDiscount = additionalDiscount > 0 &&
    (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

  return (
    <div className="thermal-total-summary">
      {!isWalletBill ? (
        <>
          <div className="thermal-total-row">
            <span>Subtotal (Taxable):</span>
            <span>₹{taxableSubTotal.toFixed(2)}</span>
          </div>

          {shouldShowAdditionalDiscount && (
            <div className="thermal-total-row thermal-discount">
              <span>Total Discount :</span>
              <span>-₹{Math.round(additionalDiscount)}</span>
            </div>
          )}

          {data?.useMembership && data?.services?.some((s) => Number(s.discount) === 100 && s.discountType === '%') && (
            <div className="thermal-total-row thermal-discount">
              <span>Membership Discount:</span>
              <span>
                -₹
                {data.services
                  .filter((s) => Number(s.discount) === 100 && s.discountType === '%')
                  .reduce((sum, s) => sum + s.price * s.quantity, 0)}
              </span>
            </div>
          )}

          {data?.coupon?.discountAmount > 0 && (
            <div className="thermal-total-row thermal-discount">
              <span>Coupon Discount:</span>
              <span>-₹{data?.coupon?.discountAmount}</span>
            </div>
          )}

          {data?.packageUniqueId?.length > 0 && data.services?.some((s) => Number(s.discount) === 100 && s.discountType === '%') && (
            <div className="thermal-total-row thermal-discount">
              <span>Package Discount:</span>
              <span>
                -₹
                {data.services
                  .filter((s) => Number(s.discount) === 100 && s.discountType === '%')
                  .reduce((sum, s) => sum + s.price * s.quantity, 0)}
              </span>
            </div>
          )}

          {data?.rewardPointRedeemAmount > 0 && (
            <div className="thermal-total-row thermal-discount">
              <span>Reward Points:</span>
              <span>-₹{data?.rewardPointRedeemAmount}</span>
            </div>
          )}

          <div className="thermal-total-row thermal-net-amount">
            <span>Net Amount:</span>
            <span>
              ₹
              {data.rewardPointRedeemAmount > 0
                ? parseFloat(data?.subTotal || 0) - data.rewardPointRedeemAmount
                : parseFloat(data?.subTotal || 0)}
            </span>
          </div>

          {(data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') &&
            (totalGstValue / 2) > 0 && (
              <>
                <div className="thermal-total-row">
                  <span>SGST:</span>
                  <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                </div>
                <div className="thermal-total-row">
                  <span>CGST:</span>
                  <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                </div>
              </>
            )}
        </>
      ) : (
        // Wallet Bill Summary
        <>
          <div className="thermal-total-row">
            <span>Amount Credited:</span>
            <span>₹{data?.amountAdded}</span>
          </div>
          <div className="thermal-total-row">
            <span>Subtotal:</span>
            <span>₹{data?.subTotal}</span>
          </div>
          {(data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') && (
            <>
              <div className="thermal-total-row">
                <span>SGST:</span>
                <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
              </div>
              <div className="thermal-total-row">
                <span>CGST:</span>
                <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
              </div>
            </>
          )}
        </>
      )}

      <div className="thermal-total-row thermal-total-payable">
        <span>Total Payable:</span>
        <span>₹{data?.amountPayable}</span>
      </div>

      <div className="thermal-total-row thermal-amount-received">
        <span>Amount Received:</span>
        <span>₹{data?.amountPaid?.reduce((a, b) => a + Number(b.amount), 0)}</span>
      </div>

      {data?.paidDues > 0 && (
        <div className="thermal-total-row thermal-due-amount">
          <span>Due Balance:</span>
          <span>₹{data?.paidDues || 0}</span>
        </div>
      )}

      {/* {data?.remainingWalletAmount && (
        <div className="thermal-total-row">
          <span>Remaining Balance:</span>
          <span>₹{data?.remainingWalletAmount}</span>
        </div>
      )} */}
        {(data?.remainingWalletAmount || 
            data?.amountPaid?.some((p) => p.paymentType === 'Wallet')) && (
            <div className="standard-summary-row">
              <span>Remaining Wallet Balance:</span>
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ₹{data?.remainingWalletAmount ?? data?.advancedGiven ?? 0}
              </span>
            </div>
          )}

      <div className="thermal-amount-words">
        <p><strong>Amount in words:</strong></p>
        <p>{formatAmountInWords(data?.amountPayable)}</p>
      </div>
       <div className="thermal-amount-words">
        <p><strong>Note:</strong></p>
        <p>{data.noteForClient}</p>
      </div>
    </div>
  );
};

export default ThermalBillPdf;
